const AnkerSolixFooter = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      // width="145"
      height="20"
      viewBox="0 0 145 20"
      fill="none"
    >
      <g clip-path="url(#clip0_8207_5687)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M67.5081 7.10372C67.5081 8.18587 66.7402 8.82515 65.5795 8.82515H61.6902V5.50372H65.5795C67.0509 5.50372 67.5081 6.51444 67.5081 7.10372ZM67.7617 11.3394C69.4009 10.0823 70.1224 8.77515 70.0045 7.09301C69.8367 4.63944 67.8545 2.99658 65.5938 2.99658H59.1152V17.1716H61.6902V11.3394H64.7331L68.3724 17.1716H71.4152L67.7617 11.3394Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M39.5 11.8712L42.825 17.1641L45.8893 17.1676L41.1679 9.66406L39.5 11.8712Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M44.9535 2.99658H41.6821L34.9428 11.9537V2.99658H32.3535V15.9144C32.3535 16.3859 32.6321 16.9752 33.3714 17.1466C33.6678 17.2144 34.2535 17.143 34.6035 16.6787C34.6464 16.6216 44.9499 2.99658 44.9499 2.99658"
          // fill="#00A9E0"
        ></path>
        <path
          d="M55.7713 8.82861H50.6855V11.3393H55.7713V8.82861Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M57.0828 2.99658H46.9863V15.9109C46.9863 16.6073 47.547 17.1716 48.247 17.1716H57.0828V14.668H49.5685V5.5073H57.0828V2.99658Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.1813 2.99658V11.9537L20.4455 2.99658H17.1562V17.1644H19.7384V6.38944C22.792 10.4323 27.4884 16.6394 27.5134 16.6787C27.867 17.1394 28.4562 17.2144 28.7491 17.1466C29.4884 16.9752 29.7634 16.3894 29.7634 15.9144V2.99658H27.1777H27.1813Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.625 3.76087L0 17.1716H2.88571L7.875 7.1073L12.8607 17.1716H15.7214L9.15 3.8073C8.90357 3.31087 8.40357 2.99658 7.85 2.99658C7.33214 2.99658 6.85357 3.29301 6.62143 3.76087"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.217 15.1641H8.50988C8.50988 15.1641 8.47774 15.1498 8.48488 15.1355L8.81703 11.4927C8.81703 11.4641 8.78488 11.4498 8.76703 11.4713L5.09203 16.2748C5.08131 16.2927 5.09203 16.3213 5.11703 16.3213H6.8206C6.83846 16.3213 6.8456 16.3355 6.8456 16.3498L6.51346 19.9927C6.51346 20.0177 6.54917 20.032 6.56346 20.0105L10.2385 15.2034C10.2385 15.2034 10.2385 15.1605 10.217 15.1605"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M144.905 3.01074H141.84L138.865 7.12146L140.394 9.23931L144.905 3.01074Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M140.012 10.4177L138.187 7.8963L134.654 3.01416H131.594L136.715 10.0927L131.594 17.1713H134.654L138.247 12.207L141.84 17.1749H144.904L140.012 10.4142V10.4177Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M116.307 3.01074H113.725V15.9C113.725 16.5929 114.285 17.1572 114.989 17.1572H123.842V14.6536H116.31V3.01074H116.307Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M126.426 17.1572H129.008V14.6536V3.01074H126.426V17.1572Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M103.915 2.85693C103.432 2.85693 102.957 2.90336 102.504 2.99622L103.154 5.50336C103.4 5.46408 103.654 5.44265 103.915 5.44265C104.229 5.44265 104.54 5.47479 104.836 5.53551L104.393 2.87479C104.236 2.86408 104.075 2.86051 103.911 2.86051"
          // fill="#00CE7C"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M109.343 5.31445L107.496 7.13231C107.853 7.56445 108.132 8.06088 108.314 8.60374L110.396 6.89302C110.114 6.3216 109.76 5.78945 109.343 5.31445Z"
          // fill="#00CE7C"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M110.996 8.66763L108.489 9.31763C108.528 9.56406 108.55 9.81763 108.55 10.0783C108.55 10.3926 108.518 10.7033 108.457 10.9998L111.118 10.5569C111.128 10.3998 111.132 10.2391 111.132 10.0748C111.132 9.59263 111.086 9.11763 110.993 8.66406"
          // fill="#00CE7C"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M106.232 3.23584L105.543 5.73227C106.079 5.93227 106.564 6.2287 106.986 6.60013L107.932 4.07513C107.411 3.72513 106.839 3.43941 106.232 3.23584Z"
          // fill="#00CE7C"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M107.389 13.1533C107.325 13.2248 107.261 13.2926 107.193 13.3605C106.354 14.1998 105.193 14.7212 103.911 14.7212C101.347 14.7212 99.2716 12.6426 99.2716 10.0819C99.2716 8.79976 99.7894 7.64262 100.632 6.79976C100.739 6.69262 100.85 6.59262 100.964 6.49619C101.397 6.13905 101.893 5.86048 102.436 5.67833L100.725 3.59619C100.154 3.87833 99.6216 4.23191 99.1466 4.64976C99.0287 4.75333 98.9144 4.86048 98.8037 4.97119C97.4966 6.27833 96.6895 8.08191 96.6895 10.0783C96.6895 14.0676 99.9216 17.2998 103.911 17.2998C105.907 17.2998 107.711 16.4926 109.018 15.1855C109.35 14.8533 109.65 14.489 109.911 14.0998C110.261 13.5783 110.547 13.0069 110.754 12.3998L108.257 11.7105C108.057 12.2462 107.761 12.7319 107.389 13.1533Z"
          // fill="#00A9E0"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M90.243 8.83949H90.1287H86.4787C85.318 8.83949 84.5501 8.20021 84.5501 7.12164C84.5501 6.53235 85.0073 5.52164 86.4787 5.52164L92.0501 5.55378L93.9787 3.01807H86.4644C84.2109 3.01807 82.2287 4.65735 82.0609 7.10735C81.9751 8.34664 82.3466 9.38592 83.2073 10.3502C83.7787 10.9931 84.6073 11.3502 85.468 11.3502H90.1323H90.2323C91.7001 11.3502 92.1608 12.3609 92.1608 12.9502C92.1608 14.0288 91.3966 14.6681 90.2323 14.6681H83.968L82.0501 17.1752H91.243C92.1037 17.1752 92.9287 16.8181 93.5037 16.1788C94.3644 15.2145 94.7359 14.1788 94.6501 12.9359C94.4823 10.4859 92.5037 8.84664 90.2466 8.84664"
          // fill="#00A9E0"
        ></path>
      </g>
      {/* <defs>
        <clipPath id="clip0_8207_5687">
          <rect width="145" height="20" fill="white"></rect>
        </clipPath>
      </defs> */}
    </svg>
  )
}

export default AnkerSolixFooter
